if(typeof productJSON != "undefined") {
    class ProductOptions {
        constructor() {

        this.product = productJSON
        this.productOptionContainer = document.querySelector("[data-product-options]")
        this.productOptions = document.querySelectorAll("[data-product-option]")
        this.selectedOptions = document.querySelectorAll("[data-product-option]:checked, [data-product-option][type='hidden']")
        this.unselectedOptions = document.querySelectorAll("[data-product-option]:not(:checked)")
        this.sectionChanged = 1
        this.contentSelection = []
        this.optionIndex = []
        this.optionCount = this.selectedOptions.length
        this.options = []
        this.selectableOptionCount = document.querySelectorAll("[data-product-option]:checked").length
        this.unselectableOptionCount = this.optionCount - this.selectableOptionCount
        this.breadcrumb = document.querySelector("[data-product-breadcrumb]")

        var _this = this

        class ContentSelection {
            constructor(optionValue) {
            this.selectedOptionContent = _this.selectedOptions[optionValue].parentNode
            this.selectedOption = _this.selectedOptions[optionValue]
            this.optionNames = []
            this.unselectedOptionsContent = []
            this.unselectedOptions = []
            
            if(this.selectedOptionContent.parentNode.tagName === 'DIV')
                this.optionSize = 1
            else 
                this.optionSize = this.selectedOptionContent.parentNode.querySelectorAll("div").length

            Array.from(_this.productOptionContainer.children).forEach(container => {
                this.optionNames.push(container.getAttribute("data-option-name"))
            })

            if(this.optionSize != 1) {
                _this.unselectedOptions.forEach((option, idx) => {
                if(this.optionNames[optionValue] === option.name) {
                    this.unselectedOptions.push(option)
                    this.unselectedOptionsContent.push(option.parentNode)
                }
                })
            }
            }

            setSelectedOption(optionValue) {
            this.selectedOptionContent = _this.selectedOptions[optionValue].parentNode
            this.selectedOption = _this.selectedOptions[optionValue]
            }

            setUnselectedOption(optionValue) {
            this.unselectedOptionsContent = []
            this.unselectedOptions = []
            if(this.optionSize != 1) {
                _this.unselectedOptions.forEach((option, idx) => {
                if(this.optionNames[optionValue] === option.name) {
                    this.unselectedOptions.push(option)
                    this.unselectedOptionsContent.push(option.parentNode)
                }
                })
            }
            }
        }

        class VariantSelection {
            constructor() {
            this.optionContainers = []
            this.optionContainersContent = []
            this.optionValues = []
            this.optionVariants = []
            this.optionSizes = []
            this.optionVariantIndexes = [] 

            Array.from(_this.productOptionContainer.children).forEach(container => {
                this.optionContainers.push(container)
            })

            this.optionContainers.forEach(container => {
                if(container.querySelectorAll("div").length === 0) {
                this.optionSizes.push(1)
                this.optionContainersContent.push(container)
                } else {
                this.optionSizes.push(container.querySelectorAll("div").length)
                this.optionContainersContent.push(container.querySelectorAll("div"))
                }

                if(container.tagName === "DIV") {
                    this.optionValues.push(container.querySelector("input").value)
                } else {
                    var tempContainer = container.querySelectorAll("input")
                    var tempHolder = []
                    tempContainer.forEach(valueInput => {
                    tempHolder.push(valueInput.value)
                    })
                    this.optionValues.push(tempHolder)
                }
                })

            this.optionMax = Math.max(...this.optionSizes)

            this.optionValues.forEach(values => {
                if(typeof values === 'string') {
                var tempHolder = []
                _this.product.variants.forEach(productVariant => {
                    if(productVariant.options.includes(values)) {
                    tempHolder.push(productVariant)
                    }
                })
                this.optionVariants.push(tempHolder)
                } else {
                var tempHolder2 = []
                values.forEach(value => {
                    var tempHolder = []
                _this.product.variants.forEach(productVariant => {
                    if(productVariant.options.includes(value))
                    tempHolder.push(productVariant)
                    })
                    tempHolder2.push(tempHolder)
                })
                this.optionVariants.push(tempHolder2)
                }
            })

            this.setVariantIndexes(_this.selectedOptions[0])
            this.setVariantShowOptions()
            this.setSelectedVariant(_this.selectedOptions[0])
            this.optionVariantID = this.selectionVariant.id
            }

            setVariantIndexes(selection) {
            this.optionVariantIndexes = []
            var sectionIndex = _this.sectionChanged - 1
            var selectionVariants = this.optionVariants[sectionIndex][_this.optionIndex[sectionIndex]]
            for(let i = 0; i < _this.optionCount; i++) {
                if(i != sectionIndex) {
                if(typeof this.optionValues[i] === 'string') {
                    var tempHolder = []
                    for(let j = 0; j < selectionVariants.length; j++) {
                    tempHolder.push(0)
                    } 
                } else {
                    var tempHolder = []
                    for(let j = 0; j < this.optionSizes[i]; j++) {
                    selectionVariants.forEach(variant => {
                        if(variant.options.includes(this.optionValues[i][j]))
                        tempHolder.push(j)
                    })
                    }
                }
                this.optionVariantIndexes.push(tempHolder)
                } else {
                var tempHolder = []
                for(let j = 0; j < selectionVariants.length; j++) {
                    tempHolder.push(_this.optionIndex[sectionIndex])
                } 
                this.optionVariantIndexes.push(tempHolder)
                }
            }
            }

            setVariantShowOptions() {
            this.resetVariantOptions()
            var sectionIndex = _this.sectionChanged - 1
            this.optionContainersContent.forEach((container, idx) => {
                this.optionVariantIndexes[idx].forEach(index => {
                if(container[index] != undefined && !container[index].classList.contains("shown")){
                    container[index].classList.add("shown")
                } else {
                    return
                }
                })
            })
            this.optionContainersContent[sectionIndex].forEach(option => {
                if (!option.classList.contains("shown"))
                    option.classList.add("shown")
            })

            this.setVariantHideOptions()
            }
            
            setVariantHideOptions() {
            this.optionContainersContent.forEach(optionContainerContent => {
                if(optionContainerContent.tagName === "DIV")
                return
                optionContainerContent.forEach(containerContent => {
                if(!containerContent.classList.contains("shown"))
                    containerContent.classList.add("not-shown")
                })
            })
            this.resetCheckedOptions()
            }

            setSelectionTitle() {
                let tempHandler = []
                _this.selectedOptions.forEach(option => {
                    tempHandler.push(option.value)
                })
                this.selectionTitle = tempHandler.join(" / ")
            }

            breadcrumbTitle() {
                let tempHandler = []
                _this.selectedOptions.forEach(option => {
                    tempHandler.push(option.value)
                })
                return tempHandler.join("/")
            }

            setSelectedVariant(selection) {
                this.setSelectionTitle()
                var sectionIndex = _this.sectionChanged - 1
                this.optionVariants[sectionIndex][selection.getAttribute("data-index")].forEach((variant, idx) => {
                    if(variant.title === this.selectionTitle) {
                        this.selectionVariant = variant
                    }
                })
                this.optionVariantID = this.selectionVariant.id
            }
                
            resetVariantOptions() {
            this.optionContainersContent.forEach(optionContainerContent => {
                if(optionContainerContent.tagName === "DIV")
                return
                optionContainerContent.forEach(containerContent => {
                containerContent.classList.remove("shown")
                containerContent.classList.remove("not-shown")
                })
            })
            }

            resetCheckedOptions() {
            var sectionIndex = _this.sectionChanged - 1
            _this.selectedOptions.forEach((option, idx) => {
                if (option.parentElement.parentNode.tagName === "DIV" || idx == sectionIndex)
                return
                else
                var firstAvailableVariant = this.optionContainersContent[idx][this.optionVariantIndexes[idx][0]].querySelector("input")
                if(_this.selectedOptions[idx] === firstAvailableVariant.value) {
                    return
                } else {
                    if(_this.selectedOptions[idx].parentElement.classList.contains("not-shown")) {
                    _this.selectedOptions[idx].checked = false
                    firstAvailableVariant.checked = true
                    _this.setSelection(firstAvailableVariant)
                    } else {
                    return
                    }
                }
            })
            }
        }

        for (let i = 0; i < _this.selectedOptions.length; i++) {
            this.contentSelection.push(new ContentSelection(i))
            this.optionIndex.push(parseInt(this.selectedOptions[i].getAttribute("data-index")))
        }

        this.variantSelection = new VariantSelection()

        this.selectedOptions.forEach(option => {
            this.options.push(option.value)
        })
        this.breadcrumb.innerHTML = this.variantSelection.breadcrumbTitle()
        }

        setContentSelection() {
        this.selectedOptions = document.querySelectorAll("[data-product-option]:checked, [data-product-option][type='hidden']")
        this.unselectedOptions = document.querySelectorAll("[data-product-option]:not(:checked)")
        for (let i = 0; i < this.selectedOptions.length; i++) {
            this.contentSelection[i].setSelectedOption(i)
            this.contentSelection[i].setUnselectedOption(i)
        }
        return true
        }

        setSelection(selection) {
            this.setContentSelection()
            this.sectionChanged = parseInt(selection.parentElement.parentNode.getAttribute("data-option-count"))
            this.optionIndex[this.sectionChanged - 1] = parseInt(selection.getAttribute("data-index"))
            this.variantSelection.setSelectedVariant(selection)
            window.history.replaceState({}, {}, `${window.location.pathname}?variant=${this.variantSelection.optionVariantID}`)
            setTimeout(() => {
                var temp = document.querySelector(".selected-variant-image")
                $('[data-main-image]').load(location.href+' [data-main-image]>*',"")
                $('[data-product-information]').load(location.href+' [data-product-information ]>*',"")
                if(temp != null && temp.classList.contains("selected-variant-image"))
                    temp.classList.remove("selected-variant-image")
            }, 300)
            this.setBreadcrumbTitle()
        }

        setBreadcrumbTitle() {
            this.breadcrumb.innerHTML = this.variantSelection.breadcrumbTitle()
        }
    }

        
    const productOptions = new ProductOptions()
    window.history.replaceState({}, {}, `${window.location.pathname}?variant=${productOptions.variantSelection.optionVariantID}`)

    productOptions.productOptions.forEach(productOption => {
        productOption.addEventListener("change", (event) => {
            productOptions.setSelection(event.target)
            productOptions.variantSelection.setVariantIndexes(event.target)
            productOptions.variantSelection.setVariantShowOptions()
        })
    })


const productPageButtons = document.querySelectorAll("[data-product-btn]")

productPageButtons.forEach(button => {
    button.addEventListener("click", () => {
        var btnName = button.getAttribute("data-product-btn")
        var quantityInput = document.querySelector("[data-product-quantity]")
        if(btnName === "increase") {
            var decreaseBtn = document.querySelector("[data-product-btn='decrease']")

            if(quantityInput.value === "")
                quantityInput.value = 1
            else if(quantityInput.value < 10000)
                quantityInput.value = parseInt(quantityInput.value) + 1
            
            if(decreaseBtn.disabled)
                decreaseBtn.disabled = false
        } else if(btnName === "decrease") {
            var increaseBtn = document.querySelector("[data-product-btn='increase']")

            if(quantityInput.value === "")
                quantityInput.value = 0
            else if(quantityInput.value > 0)
                quantityInput.value -= 1

            if(quantityInput.value == 0)
                button.disabled = true
        } else if(btnName === "add-to-cart") {
            cartJSON = getCartJSON()
            let tempProductInfo
            cartJSON.items.forEach(item => {
                if(item.id == productOptions.variantSelection.optionVariantID)
                    tempProductInfo = item
            })
            if(tempProductInfo == undefined) {
                if(quantityInput.value === "") {
                    Shopify.addItem(productOptions.variantSelection.optionVariantID, parseInt(1))
                    updateCart(1)
                } else {
                    Shopify.addItem(productOptions.variantSelection.optionVariantID, parseInt(quantityInput.value))
                    updateCart(parseInt(quantityInput.value))
                }
            } else {
                if(quantityInput.value === "") {
                    Shopify.changeItem(tempProductInfo.id, tempProductInfo.quantity + 1)
                    updateCart(1)
                } else {
                    Shopify.changeItem(tempProductInfo.id, tempProductInfo.quantity + parseInt(quantityInput.value))
                    updateCart(parseInt(quantityInput.value))
                }
            }

        }
    })
})

} else {
    const productPageButtons = document.querySelectorAll("[data-product-btn]")
    const breadcrumb = document.querySelector("[data-product-breadcrumb]")
    let selectSelection
    
    if(variantSize > 1) {
        selectSelection = document.querySelector("[data-select-selection]")
        var temp = selectSelection.children[selectSelection.selectedIndex].getAttribute("data-variant-id")
        window.history.replaceState({}, {}, `${window.location.pathname}?variant=${temp}`)
        breadcrumb.innerHTML = `${selectSelection.value}`
        selectSelection.addEventListener("change", () => {
            temp = selectSelection.children[selectSelection.selectedIndex].getAttribute("data-variant-id")
            breadcrumb.innerHTML = `${selectSelection.value}`
            window.history.replaceState({}, {}, `${window.location.pathname}?variant=${temp}`)
            setTimeout(() => {
                var temp = document.querySelector(".selected-variant-image")
                $('[data-main-image]').load(location.href+' [data-main-image]>*',"")
                $('[data-product-information]').load(location.href + ' [data-product-information ]>*', "")
                if(temp != null && temp.classList.contains("selected-variant-image"))
                    temp.classList.remove("selected-variant-image")
            }, 300)
        })
    }
    
    productPageButtons.forEach(button => {
        button.addEventListener("click", () => {
            var btnName = button.getAttribute("data-product-btn")
            var quantityInput = document.querySelector("[data-product-quantity]")
            if(btnName === "increase") {
                var decreaseBtn = document.querySelector("[data-product-btn='decrease']")

                if(quantityInput.value === "")
                    quantityInput.value = 1
                else if(quantityInput.value < 10000)
                    quantityInput.value = parseInt(quantityInput.value) + 1
                
                if(decreaseBtn.disabled)
                    decreaseBtn.disabled = false
            } else if(btnName === "decrease") {
                var increaseBtn = document.querySelector("[data-product-btn='increase']")
    
                if(quantityInput.value === "")
                    quantityInput.value = 0
                else if(quantityInput.value > 0)
                    quantityInput.value -= 1
    
                if(quantityInput.value == 0)
                    button.disabled = true
            } else if(btnName === "add-to-cart") {
                cartJSON = getCartJSON()
                let tempProductInfo
                cartJSON.items.forEach(item => {
                    if(item.id == parseInt(button.getAttribute("data-product-id")))
                        tempProductInfo = item
                })
                if(tempProductInfo == undefined) {
                    if(variantSize == 1) {
                        if(quantityInput.value === "") {
                            Shopify.addItem(parseInt(button.getAttribute("data-product-id")), 1)
                            updateCart(1)
                        } else {
                            Shopify.addItem(parseInt(button.getAttribute("data-product-id")), parseInt(quantityInput.value))
                            updateCart(parseInt(quantityInput.value))
                        }
                    } else {
                        var variantID = parseInt(selectSelection.children[selectSelection.selectedIndex].getAttribute("data-variant-id"))
                        if(quantityInput.value === "") {
                            Shopify.addItem(variantID, 1)
                            updateCart(1)
                        } else {
                            Shopify.addItem(variantID, parseInt(quantityInput.value))
                            updateCart(parseInt(quantityInput.value))
                        }
                    }
                } else {
                    if(variantSize == 1) {
                        if(quantityInput.value === "") {
                            Shopify.changeItem(tempProductInfo.id, tempProductInfo.quantity + 1)
                            updateCart(1)
                        } else {
                            Shopify.changeItem(tempProductInfo.id, tempProductInfo.quantity + parseInt(quantityInput.value))
                            updateCart(parseInt(quantityInput.value))
                        }
                    } else {
                        var variantID = parseInt(selectSelection.children[selectSelection.selectedIndex].getAttribute("data-variant-id"))
                        if(quantityInput.value === "") {
                            Shopify.changeItem(variantID, tempProductInfo.quantity + 1)
                            updateCart(1)
                        } else {
                            Shopify.changeItem(variantID, tempProductInfo.quantity + parseInt(quantityInput.value))
                            updateCart(parseInt(quantityInput.value))
                        }
                    }
                }
            }
        })
    })
}

function updateCart(itemQuantity) {
    setTimeout(() => {
        cartCount += itemQuantity
        shoppingCartCounts.forEach(shoppingCartCount => {
            if(cartCount > 99)
                shoppingCartCount.innerHTML = "99+"
            else
                shoppingCartCount.innerHTML = cartCount
        })
        updateShoppingCartCount()
        $('[data-shopping-cart-content]').load(location.href+' [data-shopping-cart-content]>*',function() {
            updateShoppingCart()
        })
    }, 1000)
}

var quantityInput = document.querySelector("[data-product-quantity]")
var carouselWidth = document.querySelector("[data-variant-image-container]")

if(carouselWidth != null)
    carouselWidth = carouselWidth.offsetWidth
var variantImages = document.querySelectorAll("[data-product-variant-image]")
const productImages = document.querySelectorAll("[data-product-image-selections]")
const carouselBtns = document.querySelectorAll("[data-product-image-btn]")
const imageCarousel = document.querySelector("[data-image-carousel]")
let currentImageX = 0
let imageCount
let imageWidth

variantImages.forEach(image => {
    if(screenWidth < 768) {
            imageCount = 3
        } else {
            imageCount = 4
        }
        imageWidth = (carouselWidth/imageCount - 1) - 8
        image.style.width = `${imageWidth}px`
})

productImages.forEach(image => {
    image.addEventListener("click", (event) => {
        var tempImage = document.querySelector(".selected-variant-image")
        var tempFeatured = document.querySelector("[data-main-image] img")
        if(!event.target.classList.contains("selected-variant-image")) {
            tempImage.classList.remove("selected-variant-image")
            event.target.parentNode.classList.add("selected-variant-image")
            tempFeatured.src = event.target.src
        }
            
    })
})

if(typeof positionCount != "undefined") {
    if(positionCount < imageCount) {
        positionCount = 0
    } else {
        positionCount = positionCount - imageCount
    }
}

let deltaX = imageWidth + 8

if(typeof positionCount != "undefined") {
    if(positionCount + (imageCount - 1) + imageCount <= variantImages.length && positionCount != 0) {
        positionCount += (imageCount - 1)
        currentImageX = -1 * (positionCount) * deltaX
    } else {
        currentImageX = -1 * (positionCount) * deltaX
    }
}

if(imageCarousel != null)
    imageCarousel.style.transform = `translateX(${currentImageX}px)`

quantityInput.addEventListener("input", (event) => {
    if(event.target.value > 10000)
        event.target.value = 10000
})

window.addEventListener("resize", () => {
    if(document.querySelector("[data-variant-image-container]") != null)
        carouselWidth = document.querySelector("[data-variant-image-container]").offsetWidth
    variantImages.forEach(image => {
        if(screenWidth < 768) {
            imageCount = 3
        } else {
            imageCount = 4
        }
        imageWidth = (carouselWidth/imageCount - 1) - 8
        image.style.width = `${imageWidth}px`
    })
    deltaX = imageWidth + 8
    positionCount = 0
    currentImageX = 0
    if(imageCarousel != null)
        imageCarousel.style.transform = "translateX(0px)"
})

carouselBtns.forEach(button => {
    var btnName = button.getAttribute("data-product-image-btn")
    button.addEventListener("click", () => {
        if(btnName === "prev") {
            if(positionCount === 0) {
                positionCount = variantImages.length - imageCount
                currentImageX = -(variantImages.length - imageCount) * deltaX
            } else {
                positionCount--
                currentImageX = -1 * (positionCount) * deltaX
            }
        } else if(btnName === "next") {
            positionCount++
            if(positionCount <= variantImages.length - imageCount)
                currentImageX = -1 * (positionCount) * deltaX
            else {
                positionCount = 0
                currentImageX = 0
            }
        }
        imageCarousel.style.transform = `translateX(${currentImageX}px)`
    })
})